import {InvoiceBodyHeader} from "./InvoiceBodyHeader";
import PropTypes from "prop-types";
import InvoiceBodyContent from "./InvoiceBodyContent";
import {InvoiceBodyFooter} from "./InvoiceBodyFooter";


export function InvoiceBody(props) {
    return (
        <div className=" w-screen m-3">
            <table className="table table-striped w-full table-responsive-sm table-sm ">
                <InvoiceBodyHeader />
                <tbody>
                    <InvoiceBodyContent contentList={props.list} setContentList={props.setList} custometId={props.customerId}
                                        priceEnable={props.enablePriceEdit}
                                        isPosted={props.isPosted} customerId={props.customerId} isApproved={props.isApproved}
                                        invoiceId={props.invoiceId} setLoading={props.setLoading} loading={props.loading} itemList={props.itemList}/>
                </tbody>
                <tfoot style={{backgroundColor: "orange"}} className="border-round-md">
                <InvoiceBodyFooter contentList={props.list}  setLoading={props.setLoading} vat={props.vat}/>
                </tfoot>
            </table>
        </div>
    )
}

InvoiceBody.propTypes = {
    setList: PropTypes.func.isRequired,
    enablePriceEdit: PropTypes.bool.isRequired,
    customerId: PropTypes.number.isRequired,
    invoiceId: PropTypes.number.isRequired,
    list: PropTypes.array.isRequired,
    isPosted: PropTypes.bool.isRequired,
    isApproved: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    itemList: PropTypes.array.isRequired,
    vat: PropTypes.number.isRequired,


}


